<script setup lang="ts">
import { computed, defineProps } from 'vue'
import {
  SpecialRequirementsTypeKey,
  SpecialRequirementsTypeLabel,
} from '../../util/enum'
const props = defineProps<{
  ada: boolean
  adaChanged?: boolean
  spab: boolean
  spabChanged?: boolean
  vehicleNeededEntireTrip: boolean
  vehicleNeededEntireTripChanged?: boolean
}>()

const selectedRequirements = computed(() => {
  return [
    {
      icon: 'busAlert',
      title: SpecialRequirementsTypeLabel.VehicleNeededEntireTrip,
      condition: props.vehicleNeededEntireTrip,
      key: SpecialRequirementsTypeKey.VehicleNeededEntireTrip,
      modified: props.vehicleNeededEntireTripChanged,
    },
    {
      icon: 'accessible',
      title: SpecialRequirementsTypeLabel.ADA,
      condition: props.ada,
      key: SpecialRequirementsTypeKey.ADA,
      modified: props.adaChanged,
    },
    {
      icon: 'school',
      title: SpecialRequirementsTypeLabel.SPAB,
      condition: props.spab,
      key: SpecialRequirementsTypeKey.SPAB,
      modified: props.spabChanged,
    },
  ].filter(({ condition }) => condition)
})
</script>

<template>
  <div v-if="selectedRequirements.length > 0" class="wheels-trip-requirements">
    <div
      v-for="requirement in selectedRequirements"
      :key="requirement.key"
      class="wheels-trip-requirements__item"
      :class="{
        'wheels-trip-requirements__item--full-width':
          requirement.key ===
          SpecialRequirementsTypeKey.VehicleNeededEntireTrip,
      }"
    >
      <div
        class="wheels-trip-requirements__content"
        :class="{
          'wheels-trip-requirements__content--modified': requirement.modified,
        }"
      >
        <WheelsSvgIcon
          :icon="requirement.icon"
          :size="20"
          class="wheels-trip-requirements__icon"
        />
        <span>{{ requirement.title }}</span>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.wheels-trip-requirements {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-family: var(--font-family-default);
  font-size: 1rem;
}
.wheels-trip-requirements__content {
  display: flex;
  align-items: center;
  gap: 4px;

  &--modified {
    background: var(--cu-blue-gray-50);
    border-radius: 4px;
  }
}
.wheels-trip-requirements__item {
  display: flex;
  align-items: center;

  &--full-width {
    flex-basis: 100%;
  }

  &:not(.wheels-trip-requirements__item--full-width) {
    flex-basis: calc(50% - 8px);
  }
}
.wheels-trip-requirements__icon {
  color: var(--cu-gray-500);
  margin-right: 4px;
}
</style>
